import { createContext } from "react";

const MainContext = createContext({
  signatories : [],
  setSignatories: () => {},
  signatoriesDocuments : {} ,
  setSignatoriesDocuments : [],
  decryptedData : "",
  setDecryptedData : () => []
  
   

});

export default MainContext;
